export default __webpack_public_path__ + "static/the-buried-chief-woman-e5d5764957b484d1c482779a689c39f0.wav";